"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectToCSSShadowVariables = void 0;
var other_1 = require("./other");
var objectToCSSShadowVariables = function (obj, withKebabCase) {
    var withPrefixDesign = false;
    return Object.keys(obj)
        .filter(function (key) { return key !== 'modes' && key !== 'comment'; })
        .reduce(function (vars, key) {
        var name = (0, other_1.join)(key);
        var value = obj[key];
        vars[(0, other_1.getCSSVariableName)(name, withPrefixDesign, withKebabCase)] = (0, other_1.getBoxShadow)(value).join(', ');
        return vars;
    }, {});
};
exports.objectToCSSShadowVariables = objectToCSSShadowVariables;
//# sourceMappingURL=objectToCSSShadowVariables.js.map